import React from "react";
import { STEPS, ASSETS } from "../../data/site";
import { PhoneFrame } from "./PhoneFrame";
import { Reveal } from "./Reveal";

export const HowItWorks = () => (
  <section
    id="how-it-works"
    className="relative overflow-hidden bg-[#111E16] py-24 text-white md:py-32"
    data-testid="how-it-works-section"
  >
    <div
      className="pointer-events-none absolute -left-32 top-1/3 h-[440px] w-[440px] rounded-full opacity-20 blur-3xl"
      style={{ background: "radial-gradient(circle, #2F5E43 0%, transparent 70%)" }}
    />
    <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-6 md:grid-cols-2 md:px-12">
      <div>
        <Reveal>
          <p className="text-sm font-semibold uppercase tracking-[0.15em] text-[#8AA583]">
            How it works
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-heading mt-5 text-4xl font-semibold leading-[1.15] tracking-tight md:text-5xl">
            Get set up in four simple steps.
          </h2>
        </Reveal>

        <div className="mt-12 space-y-8">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.1}>
              <div className="flex gap-5">
                <span className="font-heading flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#2F5E43] text-lg font-semibold text-white">
                  {s.num}
                </span>
                <div>
                  <h3 className="font-heading text-xl font-semibold">{s.title}</h3>
                  <p className="mt-1.5 leading-relaxed text-white/70">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.2} className="flex justify-center">
        <PhoneFrame
          src={ASSETS.sosActive}
          alt="SisterSafe SOS Active screen"
          testId="how-it-works-mockup"
          className="w-[68%] max-w-[280px]"
        />
      </Reveal>
    </div>
  </section>
);
